import {
  useFormContext,
  type FieldPath,
  type FieldValues,
} from "react-hook-form"

import {
  FormField,
  FormControl,
  FormItem,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Slider } from "@/components/ui/slider"

export type FormSliderProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  placeholder?: string
  className?: string
  disabled?: boolean
  type?: string
  max?: number
}

export function FormSlider<T extends FieldValues = FieldValues>({
  name,
  placeholder,
  className,
  disabled = false,
  max = 100,
}: FormSliderProps<T>) {
  const form = useFormContext<T>()
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-2">
          <Label htmlFor={name}>Ownership</Label>
          <div className="flex items-center gap-4">
            <div className="flex-1">
              <Slider
                value={[Number(field.value) || 0]}
                max={max}
                step={1}
                min={0}
                onValueChange={(value) => {
                  field.onChange(value[0])
                }}
              />
            </div>
            <FormControl>
              <Input
                placeholder={placeholder}
                className={className}
                disabled={disabled}
                type="number"
                min={0}
                max={max}
                {...field}
                onChange={(e) => {
                  const value = Number(e.target.value)
                  const clampedValue = Math.min(Math.max(value, 0), max)
                  field.onChange(clampedValue)
                }}
              />
            </FormControl>
            <span className="ml-1 text-sm">%</span>
          </div>
          <FormMessage className="form-error" />
        </FormItem>
      )}
    />
  )
}
